
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { fetchSingleQuotationApi } from "../../../api/quotationApi";
import { pricingPolicyOptions } from "../../../utils/constants"
import moment from "moment";


export const generateExcel = async (
  token,
  quotId,
) => {
  try {
      
      const formattedDate = moment().format('YYYYMMDD');
      const workbook = new ExcelJS.Workbook();

      const excelResponse = await fetchExcelApiDetails(token, quotId);

      if (Object.keys(excelResponse).length == 0) {
        return;
      }
      const formattedFinalData = await formattedPRoductStatementData(excelResponse);
      console.log("formattedFinalData-->", formattedFinalData);
      

      
      // The Workbook vieworksheet controls how many separate windoworksheet Excel will open when viewing the workbook.
      workbook.vieworksheet = [
        {
          x: 0,
          y: 0,
          width: 10000,
          height: 20,
          firstSheet: 0,
          activeTab: 1,
          visibility: "visible",
        },
      ];

      // Add a Worksheet create a sheet with red tab color
      const worksheet = workbook.addWorksheet("Quotation", {
        properties: { tabColor: { argb: "FFC0000" } },
      });

      // Set column widths
      worksheet.columns = [
        { width: 10 }, // A
        { width: 5 }, // B
        { width: 5 }, // C
        { width: 20 }, // D
        { width: 15 }, // E
        { width: 15 }, // F
        { width: 17 }, // G
        { width: 5 }, // H
        { width: 2 }, // I
        { width: 3 }, // J
        { width: 4 }, // K
        { width: 5 }, // L
        { width: 6 }, // M
        { width: 8 }, // N
        { width: 12 }, // O
        { width: 17 }, // P
        { width: 10 }, // Q
        { width: 17 }, // R
        { width: 17 }, // S
        { width: 5 }, // T
        { width: 12 }, // U
        { width: 15 }, // V
        { width: 18 }, // W
        { width: 15 }, // X
      ];

      // ### Set background color for the entire worksheet
      const fillLightGreenColor = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D2F7D2" }, // #Light green color
      };
      const fillWhiteColor = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFFFF" }, // #White color
      };
      const defaultRowNum = 40; // For extra space 
      const totalRows =  parseInt(formattedFinalData.totalRows + defaultRowNum)
      const extraEmptyRows = parseInt(totalRows -8) // 8 extra white space
      for (let row = 1; row <= totalRows; row++) {
        for (let col = 1; col <= 30; col++) {
          if (row == 1 || col == 1 || col > 20 || row > extraEmptyRows) {
            worksheet.getCell(row, col).fill = fillLightGreenColor;
          } else if(row <= extraEmptyRows) {
            worksheet.getCell(row, col).fill = fillWhiteColor;
          }
        }
      }


      // ---------------------#Logo Image--------------------------
      // formattedFinalData.appData?.logo ||
      const companyLogo =  "/datacoreLogo.png";
      const companyTag  =  formattedFinalData.appData?.tag_line;
      const arabicTagLine  = formattedFinalData.appData?.arabic_tag_line;
      const companyTitle  =  formattedFinalData.appData.title
      const customer  =  formattedFinalData.customer;
      const project  =  formattedFinalData.project
      const CrmRefNumber  =  formattedFinalData.crm_ref_number;
      const QuotRefNumber  =  formattedFinalData.quote_ref_number;
      const tax  = { type : formattedFinalData.appData.tax_name, taxNumber : formattedFinalData.appData.tax_no,}
      const quotCreatedAt  =  moment(formattedFinalData.created_at ).format('dd-mm-yy')
      const version = formattedFinalData. version 
      // console.log("formattedDate.appData", customer?.name);

      const response = await fetch(companyLogo);
      const imageBlob = await response.blob();
      const imageBuffer = await imageBlob.arrayBuffer();
      const imageId = workbook.addImage({
        buffer: imageBuffer,
        extension: "png",
      });
      worksheet.addImage(imageId, {
        tl: { col: 2, row: 3 }, // Top-left corner of the image (Column C, Row 4)
        ext: { width: 250, height: 70 }, // Set the width and height of the image in pixels
      });
      // ---------------------#Logo Image END--------------------------

      worksheet.mergeCells("C7:F7");
      const cellC7 = worksheet.getCell("C7");
      cellC7.value = companyTag || "AN ISO 9001:2015 CERTIFIED COMPANY";
      cellC7.font = {
        color: { argb: "#020302" },
        size: 10,
        bold: true,
      };
      cellC7.alignment = {
        horizontal: "left", // Align text to the left
        vertical: "canter", // Align text vertically in the middle
        indent: 5, // Indent level (1 level = 5px, so 2 levels = 10px)
      };
      worksheet.getRow(7).height = 25;

      // #Right side head
      worksheet.mergeCells("G5:S5");
      const cellS5 = worksheet.getCell("S5");
      cellS5.value = arabicTagLine || "شركة البيانات الاساسية للاتصالات وتقنية المعلومات";
      cellS5.font = {
        color: { argb: "7a807f" },
        size: 14,
        bold: false,
      };
      worksheet.getCell("S4").alignment = { wrapText: true };

      worksheet.mergeCells("Q6:S6");
      worksheet.getCell("S6").value = companyTitle || "DataCore Solutions";
      worksheet.getCell("S6").alignment = {
        horizontal: "right",
        vertical: "middle",
      };
      worksheet.getCell("S6").font = {
        color: { argb: "FF039e84" },
        size: 25,
        bold: true,
      };

      worksheet.mergeCells("Q7:S7");
      const cellS7 = worksheet.getCell("S7");
      cellS7.value = "Technology Integrators . . . . ";
      cellS7.alignment = { horizontal: "right", vertical: "middle" };
      cellS7.font = {
        color: { argb: "#020302" },
        size: 12,
        bold: true,
      };

      // For design Horizontal line
      worksheet.mergeCells("B9:T9");
      worksheet.getCell("G9").border = {
        top: { style: "thin", color: { argb: "000000" } }, // Thin black line
      };
      worksheet.getRow(9).height = 2;

      // ------------------- > Quotation detailed address
      // Q U O T A T I O N
      worksheet.mergeCells("C11:S11");
      const cellC11 = worksheet.getCell("C11"); // Use C11 since it's the start of the merged range
      cellC11.value = "Q U O T A T I O N";
      cellC11.alignment = { horizontal: "center", vertical: "middle" };
      cellC11.font = {
        color: { argb: "#020302" },
        size: 15,
        bold: false,
      };

      // #Address

      // Add your image as before
      const roundBorderImg = await fetch("/roundBorder.png");
      const roundBorderImgBlob = await roundBorderImg.blob();
      const roundBorderImgBuffer = await roundBorderImgBlob.arrayBuffer();
      const roundBorderImgId = workbook.addImage({
        buffer: roundBorderImgBuffer,
        extension: "png",
      });

      // Define the range for the image
      const startRow = 13;
      const endRow = 19;
      const startCol = 3; // Column C
      const endCol = 8; // Column H

      // Calculate the width and height of the image in pixels
      const rowHeight = 20; // Adjust as needed
      const totalHeight = (endRow - startRow + 1) * rowHeight;
      const totalWidth = 600; // Approximate width

      // Add 1 st  image
      worksheet.addImage(roundBorderImgId, {
        tl: { col: startCol - 1, row: startRow - 1 }, // Adjusting for 0-based index
        ext: { width: totalWidth, height: totalHeight },
      });

      // Add 2 nd  image
      worksheet.addImage(roundBorderImgId, {
        tl: { col: startCol + 10 - 1, row: startRow - 1 }, // Adjusting for 0-based index
        ext: { width: totalWidth, height: totalHeight },
      });

      // Add text over the image by placing it in the cells

      // #To
      const textToCell = worksheet.getCell("C14");
      textToCell.value = "To:";
      textToCell.alignment = {
        vertical: "center",
        horizontal: "left",
        indent: 1,
      };
      textToCell.font = {
        italic: true,
      };
      worksheet.mergeCells("E14:G14");
      worksheet.getCell("E14").value = customer?.name || "";

      // #Address
      worksheet.mergeCells("C15:D15");
      const textAddressCell = worksheet.getCell("C15");
      textAddressCell.value = "Address:";
      textAddressCell.alignment = {
        vertical: "center",
        horizontal: "left",
        indent: 1,
      };
      textAddressCell.font = {
        italic: true,
      };
      worksheet.mergeCells("E15:G15");
      worksheet.mergeCells("E16:G16");
      worksheet.mergeCells("E17:G17");

      // #Subject
      worksheet.mergeCells("C18:D18");
      const textSubjectCell = worksheet.getCell("C18");
      textSubjectCell.value = "Subject:";
      textSubjectCell.alignment = {
        vertical: "center",
        horizontal: "left",
        indent: 1,
      };
      textSubjectCell.font = {
        italic: true,
      };
      worksheet.mergeCells("E18:G18");
      worksheet.getCell("E18").value = `${project || ""}`;
      worksheet.getCell("E18").font = { bold: true };
      // <---------Right side----------->
      // #Date
      worksheet.mergeCells("M14:N14");
      const textDateCell = worksheet.getCell("M14");
      textDateCell.value = "Date:";
      textDateCell.alignment = {
        vertical: "center",
        horizontal: "left",
        indent: 1,
      };
      textDateCell.font = {
        italic: true,
      };
      worksheet.mergeCells("P14:R14");
      const cellP14 = worksheet.getCell("P14");
      cellP14.value = quotCreatedAt;

      // #CRM ref
      worksheet.mergeCells("M15:N15");
      const textOurRefCell = worksheet.getCell("M15");
      textOurRefCell.value = "CRM ref:";
      textOurRefCell.alignment = {
        vertical: "center",
        horizontal: "left",
        indent: 1,
      };
      textOurRefCell.font = {
        italic: true,
      };
      worksheet.mergeCells("P15:R15");
      const cellP15 = worksheet.getCell("P15");
      cellP15.value = `${CrmRefNumber || ""}`;

      // #Tel
      worksheet.mergeCells("M16:N16");
      const textTelCell = worksheet.getCell("M16");
      textTelCell.value = "Quot ref:";
      textTelCell.alignment = {
        vertical: "center",
        horizontal: "left",
        indent: 1,
      };
      textTelCell.font = {
        italic: true,
      };
      worksheet.mergeCells("P16:R16");
      const cellP16 = worksheet.getCell("P16");
      cellP16.value = `${QuotRefNumber || ""}`;

      // #Version
      worksheet.mergeCells("M17:N17");
      const textVersionCell = worksheet.getCell("M17");
      textVersionCell.value = `Version:`
      textVersionCell.alignment = {
        vertical: "center",
        horizontal: "left",
        indent: 1,
      };
      worksheet.mergeCells("P17:R17");

      const cellP17 = worksheet.getCell("P17");
      cellP17.value = `V${version || 1}`  //-------------

      // Tax
      worksheet.mergeCells("M18:N18");
      const textVatNoCell = worksheet.getCell("M18");
      textVatNoCell.value = `${tax.type} NO:`
      textVatNoCell.alignment = {
        vertical: "center",
        horizontal: "left",
        indent: 1,
      };
      textVatNoCell.font = {
        italic: true,
        bold: true,
      };

      worksheet.mergeCells("P18:R18");

      const cellP18 = worksheet.getCell("P18");
      cellP18.value = `${tax.taxNumber}` || "" //-------------

      // Description
      // worksheet.getCell('C20').value = 'Dear'
      // worksheet.mergeCells('C21:R21');
      // worksheet.getCell('C21').value = 'We would like to thank you for giving us an opportunity to quote for the subject requirement. As per your request, please find below our best offer for your kind review and approval.'

      // <---------------------------------------------PRODUCT DATA SETTING---------------------------------------------------->

      //<-------------------TABLE HEADER----------------->
      // #HEADER
      const headers = [
        "#",
        "Description",
        "Unit",
        "Qty",
        "U.Cost (SR)",
        "T.Cost (SR)",
        "%",
        "U.Price (SR)",
        "T.Price (SR)",
      ];
      const headRowIndex = 24;
      const headerBorder = {
        top: { style: "hair" },
        left: { style: "hair" },
        bottom: { style: "hair" },
        right: { style: "hair" },
      };
      const headCellFillBlue = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFC7E2EB" },
      };
      const headCellFillRed = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "EDBDBD" },
      };
      const centerAlignment = { horizontal: "center", vertical: "middle" };

      const setHeadCellProperties = (cell, value, headCellFill) => {
        cell.value = value;
        cell.border = headerBorder;
        cell.fill = headCellFill;
        cell.alignment = centerAlignment;
        cell.font = { bold: true };
      };

      // #
      const cellHHash = worksheet.getCell(`C${headRowIndex}`);
      setHeadCellProperties(cellHHash, "#", headCellFillBlue);

      // #Description
      const emptyHeadCell = worksheet.getCell(`D${headRowIndex}`);
      emptyHeadCell.border = headerBorder;
      emptyHeadCell.fill = headCellFillBlue;
      const description = "Description";
      const targetCells = ["E", "F", "G", "H", "I", "J", "K", "L"];
      worksheet.getCell(`E${headRowIndex}`).value = description;
      // Apply formatting (like borders) to make it look merged
      targetCells.forEach((column) => {
        const cell = worksheet.getCell(`${column}${headRowIndex}`);
        cell.alignment = centerAlignment;
        cell.border = {
          top: { style: "hair" },
          left: { style: column === "E" ? "hair" : "none" }, // only left border for the first cell
          bottom: { style: "hair" },
          right: { style: column === "L" ? "hair" : "none" }, // only right border for the last cell
        };
        cell.fill = headCellFillBlue;
        cell.font = { bold: true };
      });

      // #Units
      setHeadCellProperties(worksheet.getCell(`M${headRowIndex}`), "Unit",headCellFillBlue);

      // #Quantity
      setHeadCellProperties(worksheet.getCell(`N${headRowIndex}`), "Qty", headCellFillBlue);

      // #Unit Cost
      setHeadCellProperties(worksheet.getCell(`O${headRowIndex}`), "U. Cost (SR)", headCellFillBlue);

      // #Total Cost
      setHeadCellProperties(worksheet.getCell(`P${headRowIndex}`), "T. Cost (SR)", headCellFillBlue);

      // #Percentage
      setHeadCellProperties(worksheet.getCell(`Q${headRowIndex}`), "%", headCellFillBlue);

      // #Unit Price
      setHeadCellProperties(worksheet.getCell(`R${headRowIndex}`), "U. Price (SR)", headCellFillBlue);

      // #Total Price
      setHeadCellProperties(worksheet.getCell(`S${headRowIndex}`), "T. Price (SR)", headCellFillBlue);

      // # Discount
      setHeadCellProperties(worksheet.getCell(`U${headRowIndex}`), "Discount",headCellFillRed);

      // #U.Price (Vendor)
      setHeadCellProperties(worksheet.getCell(`V${headRowIndex}`), "U.Price (Vendor)", headCellFillRed);

      // #T.Price (Vendor)
      setHeadCellProperties(worksheet.getCell(`W${headRowIndex}`), "T.Price (Vendor)", headCellFillRed);

      // #	Total Profit
      setHeadCellProperties(worksheet.getCell(`X${headRowIndex}`), "Total Profit", headCellFillRed);

      // Empty space cell
      worksheet.mergeCells(`C25:S25`);
      worksheet.getRow(25).height = 5;

      //<-------------------TABLE BODY----------------------------------->


      const sectionRowIndexStart = 25; // Initial row index
      let currentRowIndex = sectionRowIndexStart;

    // Helper function to set cell styles
    const setCellStyles = (cell, { alignment, border, font, fill }) => {

      if (alignment) cell.alignment = alignment;
      if (border) cell.border = border;
      if (font) cell.font = font;
      if (fill) cell.fill = fill;
    };

    // Helper function for border styles
    const getDefaultBorder = () => ({
      top: { style: "hair" },
      left: { style: "hair" },
      bottom: { style: "hair" },
      right: { style: "hair" },
    });
    if(formattedFinalData.isSectionActive){
      // Process each main section
      formattedFinalData.productData.forEach((mainSection) => {
        currentRowIndex += 1;
        // Main Section Header
        worksheet.getCell(`C${currentRowIndex}`).value = mainSection.hashLabel;
        setCellStyles(worksheet.getCell(`C${currentRowIndex}`), {
          alignment: { horizontal: "center", vertical: "middle" },
          border: getDefaultBorder(),
          font: { bold: true, color: { argb: "FFFF0000" } },
        });

        worksheet.mergeCells(`D${currentRowIndex}:L${currentRowIndex}`);
        const sectionCell = worksheet.getCell(`D${currentRowIndex}`);
        sectionCell.value = mainSection.section;
        setCellStyles(sectionCell, {
          alignment: { horizontal: "start", vertical: "middle" },
          font: { bold: true },
          fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFCCD7FF" } },
          border: getDefaultBorder(),
        });

          const detailColumns = ["M", "N", "O", "P", "Q", "R", "S","U","V","W","X"];
          detailColumns.forEach((col, index) => {
            const cell = worksheet.getCell(`${col}${currentRowIndex}`);
            cell.border =  getDefaultBorder()
          });
          const mergedRangesMainSection =[];
        // Process Main Section Product Data
        if (mainSection.productData && mainSection.productData.length > 0) {

          const detailColumns = ["C","D", "E",'F', "M", "N", "O", "P", "Q", "R", "S","U","V","W","X"];
          mainSection.productData.forEach((product, productIndex) => {
            currentRowIndex += 1; // Move to the next row
            detailColumns.forEach((col) => {
              const cell = worksheet.getCell(`${col}${currentRowIndex}`);
              switch (col) {
                case "C":
                  cell.value = productIndex+1
                  break;
                case "D":
                  cell.value = product.name;
                  cell.alignment = { horizontal: "start", vertical: "middle" }
                  cell.border =  getDefaultBorder()
                  break;
                case "E":
                  cell.value = product.manufacture;
                  cell.alignment = { horizontal: "start", vertical: "middle" }
                  cell.border =  getDefaultBorder()
                  break;
                case "F":

                  const mergeRange = `F${currentRowIndex}:L${currentRowIndex}`;
                  // Check if the range is already merged
                  if (!mergedRangesMainSection.includes(mergeRange)) {
                    worksheet.mergeCells(mergeRange);
                    mergedRangesMainSection.push(mergeRange); // Track the merged range
                  }
          
                  const mergedCell = worksheet.getCell(`F${currentRowIndex}`);
                  mergedCell.value = product.description;
                  worksheet.getRow(currentRowIndex).height  =30
                  mergedCell.alignment = { horizontal: "start", vertical: "middle" , wrapText: true};
                  setCellStyles(mergedCell, { border: getDefaultBorder() });
                  break;
                case "M":
                  cell.value = 'Ea';
                  break;
                case "N":
                  cell.value = product.quantity;
                  break;
                case "O":
                  cell.value = parseFloat(product.u_cost || 0);
                  break;
                case "P":
                  cell.value = parseFloat(product.t_cost);
                  break;
                case "Q":
                  cell.value =product.standard_markup ?  `${parseFloat(product.standard_markup)}%` : '';
                  break;
                case "R":
                  cell.value = parseFloat(product.u_price);
                  break;
                case "S":
                  cell.value = parseFloat(product.t_price);
                  break;
                case "U":
                  cell.value = product.v_discount ? `${parseFloat(product.v_discount)}%` : ''
                  break;
                case "V":
                  cell.value = parseFloat(product.v_unit_cost);
                  break;
                case "W":
                  cell.value = parseFloat(product.v_total_cost);
                  break;
                case "X":
                  cell.value = parseFloat(product.v_total_profit);
                  break;
                default:
                  cell.value = ""; // No action for other columns
                  break;
              }
              if(col !=='D' && col !=='E' && col !=='F'){
                setCellStyles(cell, {
                  alignment: { horizontal: "center", vertical: "middle" },
                  border: getDefaultBorder(),
                });
              }
            });
          });
        }

        // Process Subsections
        if (mainSection.subSection && mainSection.subSection.length > 0) {
          mainSection.subSection.forEach((subSection) => {
            currentRowIndex += 1; // Move to the next row
            worksheet.getCell(`C${currentRowIndex}`).value = subSection.hashLabel;
            setCellStyles(worksheet.getCell(`C${currentRowIndex}`), {
              alignment: { horizontal: "center", vertical: "middle" },
              border: getDefaultBorder(),
              font: { bold: true, color: { argb: "FFFF0000" } },
            });

            worksheet.mergeCells(`D${currentRowIndex}:L${currentRowIndex}`);
            const subSectionCell = worksheet.getCell(`D${currentRowIndex}`);
            subSectionCell.value = subSection.section;
            setCellStyles(subSectionCell, {
              alignment: { horizontal: "start", vertical: "middle" },
              font: { bold: true },
              fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFCCD7FF" } },
              border: getDefaultBorder(),
            });
            const detailColumns = ["M", "N", "O", "P", "Q", "R", "S", "U","V","W","X"];
            detailColumns.forEach((col, index) => {
              const cell = worksheet.getCell(`${col}${currentRowIndex}`);
              cell.border =  getDefaultBorder()
            });
        
            // Process Subsection Product Data
            if (subSection.productData && subSection.productData.length > 0) {
              subSection.productData.forEach((product, productIndex) => {
                currentRowIndex += 1; // Move to the next row
                const detailColumns = ["C","D", "E", "F","M", "N", "O", "P", "Q", "R", "S","U","V","W","X"];
                detailColumns.forEach((col) => {
                  const cell = worksheet.getCell(`${col}${currentRowIndex}`);
                  switch (col) {
                    case "C":
                      cell.value = productIndex+1
                      break;
                    case "D":
                      cell.value = product.name;
                      cell.alignment = { horizontal: "start", vertical: "middle" }
                      cell.border =  getDefaultBorder()
                      break;
                    case "E":
                      cell.value = product.manufacture;
                      cell.alignment = { horizontal: "start", vertical: "middle" }
                      cell.border =  getDefaultBorder()
                      break;
                    case "F":

                      const mergeRange = `F${currentRowIndex}:L${currentRowIndex}`;           
                      // // Check if the range is already merged
                      if (!mergedRangesMainSection.includes(mergeRange)) {
                        worksheet.mergeCells(mergeRange);
                        mergedRangesMainSection.push(mergeRange); // Track the merged range
                      }
              
                      const mergedCell = worksheet.getCell(`F${currentRowIndex}`);
                      cell.value = product.description;
                      worksheet.getRow(currentRowIndex).height  =30
                      cell.alignment = { horizontal: "start", vertical: "middle", wrapText: true };
                      setCellStyles(cell, { border: getDefaultBorder() });
                      break
                    case "M":
                      cell.value =  'Ea';
                      break;
                    case "N":
                      cell.value = product.quantity;
                      break;
                    case "O":
                      cell.value = parseFloat(product.u_cost || 0);
                      break;
                    case "P":
                      cell.value = parseFloat(product.t_cost || 0);
                      break;
                    case "Q":
                      cell.value =product.standard_markup ?  `${parseFloat(product.standard_markup)}%` : '';
                      break;
                    case "R":
                      cell.value = parseFloat(product.u_price || 0);
                      break;
                    case "S":
                      cell.value = parseFloat(product.t_price || 0);
                      break;
                    case "U":
                      cell.value = product.v_discount ? `${parseFloat(product.v_discount || 0)}%` : ''
                      break;
                    case "V":
                      cell.value = parseFloat(product.v_unit_cost || 0);
                      break;
                    case "W":
                      cell.value = parseFloat(product.v_total_cost || 0);
                      break;
                    case "X":
                      cell.value = parseFloat(product.v_total_profit || 0);
                      break;
                    default:
                      cell.value = ""; // No action for other columns
                      break;
                  }
                  if(col !=='D' && col !=='E' && col !=='F'){
                    setCellStyles(cell, {
                      alignment: { horizontal: "center", vertical: "middle" },
                      border: getDefaultBorder(),
                    });
                  }

                });
              });
            }
          });
        }
      });
    }else{
      // Process product data
      formattedFinalData.productData?.forEach((product, pIndex) => {
        const mergedRangesMainSection =[];
        const detailColumns = ["C","D", "E",'F', "M", "N", "O", "P", "Q", "R", "S","U","V","W","X"];
        currentRowIndex += 1;
        detailColumns.forEach((col) => {
          const cell = worksheet.getCell(`${col}${currentRowIndex}`);
          switch (col) {
            case "C":
              cell.value = pIndex+1
              break;
            case "D":
              cell.value = product.name;
              cell.alignment = { horizontal: "start", vertical: "middle" }
              cell.border =  getDefaultBorder()
              break;
            case "E":
              cell.value = product.manufacture;
              cell.alignment = { horizontal: "start", vertical: "middle" }
              cell.border =  getDefaultBorder()
              break;
            case "F":

              const mergeRange = `F${currentRowIndex}:L${currentRowIndex}`;
              // Check if the range is already merged
              if (!mergedRangesMainSection.includes(mergeRange)) {
                worksheet.mergeCells(mergeRange);
                mergedRangesMainSection.push(mergeRange); // Track the merged range
              }
      
              const mergedCell = worksheet.getCell(`F${currentRowIndex}`);
              mergedCell.value = product.description;
              mergedCell.alignment = { horizontal: "start", vertical: "middle", wrapText: true };
              worksheet.getRow(currentRowIndex).height  =30
              setCellStyles(mergedCell, { border: getDefaultBorder() });
              break;
            case "M":
              cell.value = 'Ea';
              break;
            case "N":
              cell.value = product.quantity;
              break;
            case "O":
              cell.value = parseFloat(product.u_cost || 0);
              break;
            case "P":
              cell.value = parseFloat(product.t_cost);
              break;
            case "Q":
              cell.value =product.standard_markup ?  `${parseFloat(product.standard_markup)}%` : '';
              break;
            case "R":
              cell.value = parseFloat(product.u_price);
              break;
            case "S":
              cell.value = parseFloat(product.t_price);
              break;
            case "U":
              cell.value = product.v_discount ? `${parseFloat(product.v_discount)}%` : ''
              break;
            case "V":
              cell.value = parseFloat(product.v_unit_cost);
              break;
            case "W":
              cell.value = parseFloat(product.v_total_cost);
              break;
            case "X":
              cell.value = parseFloat(product.v_total_profit);
              break;
            default:
              cell.value = ""; // No action for other columns
              break;
          }
          if(col !=='D' && col !=='E' && col !=='F'){
            setCellStyles(cell, {
              alignment: { horizontal: "center", vertical: "middle" },
              border: getDefaultBorder(),
            });
          }
        });
      });
    }



      
      


      // # Removing border
      const cellsToClearBorder = [
        "G5",
        "Q6",
        "Q7",
        "C7",
        "C11",
        "C13",
        "C14",
        "C15",
        "C18",
        "M14",
        "M15",
        "M16",
        "M17",
        "C20",
        "C21",
        "C25",
      ];
      cellsToClearBorder.forEach((cell) => {
        worksheet.getCell(cell).border = {};
      });

      // #Adding dotted border
      const cellsWithDottedBorder = [
        "E14",
        "E15",
        "E16",
        "E17",
        "E18",
        "P14",
        "P15",
        "P16",
        "P17",
        "P18",
      ];
      const dottedBorderStyle = {
        bottom: { style: "dotted", color: { argb: "FFA7A8A7" } },
      };

      cellsWithDottedBorder.forEach((cell) => {
        worksheet.getCell(cell).border = dottedBorderStyle;
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Use file-saver to save the file
      
      saveAs(blob, `Quote-${QuotRefNumber}-${project}-V${version}-${formattedDate}`);
      return true
  } catch (error) {
    console.log("Error in generateExcel function", error.message);
  }
};

// Usage Example
// const range = "F27"; // Specify the range to check
// if (isRangeMerged(worksheet, range)) {
//   console.log(`Range ${range} is already merged.`);
// } else {
//   console.log(`Range ${range} is not merged yet.`);
// }
// Check function for already merged or not 
function isRangeMerged(worksheet, range) {
  return Object.keys(worksheet._merges).includes(range);
}


async function fetchExcelApiDetails(token, quotId) {
  try {
    const isExcel = true;
    const response = await fetchSingleQuotationApi(token, quotId, isExcel);
    if (response.code == 200) {
      return response.data;
    }
    return {};
  } catch (error) {}
}

function calculateVendorUnitCost(pricingPolicy, basePrice, discountValue){
  const vendorUnitCost =
  (pricingPolicy == pricingPolicyOptions.standard_pricing.value ||
    pricingPolicy == pricingPolicyOptions.distributor_discount.value ||
    pricingPolicy == pricingPolicyOptions.manufacture_discount.value)
    ? basePrice > 0
      ? (pricingPolicy == pricingPolicyOptions.distributor_discount.value ||
        pricingPolicy == pricingPolicyOptions.manufacture_discount.value)
        ? basePrice - basePrice * (discountValue / 100)
        : basePrice // Fallback to basePrice if not a specific discount type
      : '0'
    : '0';
    return vendorUnitCost
}

function calculateUnitPrice(pricingPolicy, standardMarkup, basePrice){
  const unitPrice =
    pricingPolicy === pricingPolicyOptions.manufacture_discount.value 
      ? // Case 3: Manufacture Discount
      (basePrice * (1 - parseFloat(standardMarkup || 0) / 100)).toFixed(2)
      : 
      (basePrice * (1 + parseFloat(standardMarkup || 0) / 100)).toFixed(2);
    return unitPrice
}

async function formattedPRoductStatementData(quotData) {
    try{


      const isSectionActive = quotData.is_section_active; 
      const productData = quotData.product_data || [];
      let totalRows = 1
      let formattedFinalData = {
        appData: quotData.appData,
        quote_ref_number : quotData.quote_ref_number,
        crm_ref_number : quotData.crm_ref_number,
        version : quotData.version,
        created_at : quotData.created_at,
        created_by : quotData.created_by,
        customer : quotData.customer,
        project  : quotData.subject,
        productData: [],
        totalRows : 1,
        isSectionActive : isSectionActive
      }; 

      let formattedProductData = [];

        if (isSectionActive) {
          productData.forEach((sectionData, sectionIndex) => {
            totalRows +=1;
            // Main Section
            const sectionObject = {
              hashLabel: String.fromCharCode(65 + sectionIndex), // Generate A, B, C, ...
              section: sectionData.section, // Copy the section value
              productData: [],
              subSection: []
            };

            // Main Section Products
            sectionData.products.forEach((mainSectionProduct) => {
                totalRows +=1;
                const basePrice = parseFloat(mainSectionProduct.converted_price || 0)
                const discountValue = parseFloat(mainSectionProduct.discount || 0);
                const vendorUnitCost = calculateVendorUnitCost(mainSectionProduct.pricing_policy, basePrice, discountValue)
  
                const vendorTotalCost = vendorUnitCost * mainSectionProduct.quantity
                const totalCost = (basePrice * (mainSectionProduct.quantity || 0)).toFixed(2);
                const unitPrice = calculateUnitPrice(mainSectionProduct.pricing_policy, mainSectionProduct.standard_markup, basePrice)
     
          
                const vendorTotalProfit = parseFloat(mainSectionProduct.total_price) - parseFloat(vendorTotalCost)

              // Add main product
              sectionObject.productData.push({
                isMainSectionProduct: true,
                name: mainSectionProduct.product_name,
                manufacture: mainSectionProduct.manufacture,
                description: mainSectionProduct.description,
                unit_type : mainSectionProduct.unit_type,
                quantity: mainSectionProduct.quantity,
                pricingPolicy : mainSectionProduct.pricing_policy,
                u_cost : basePrice,
                t_cost : totalCost,
                standard_markup : mainSectionProduct.standard_markup,
                u_price : unitPrice,
                t_price : mainSectionProduct.total_price,
                v_discount : discountValue || '',
                v_unit_cost:parseFloat(vendorUnitCost)?.toFixed(2),
                v_total_cost : vendorTotalCost.toFixed(2),
                v_total_profit : vendorTotalProfit.toFixed(2),
              });

              // Add supporting products
              if (mainSectionProduct.supporting_products && mainSectionProduct.supporting_products.length > 0) {
                mainSectionProduct.supporting_products.forEach((supportingProduct) => {
                  totalRows +=1;

                  const basePrice = parseFloat(supportingProduct.converted_price || 0)
                  const discountValue = parseFloat(supportingProduct.discount || 0);
                  const vendorUnitCost = calculateVendorUnitCost(supportingProduct.pricing_policy, basePrice, discountValue)
    
                  const vendorTotalCost = vendorUnitCost * supportingProduct.quantity
                  const totalCost = basePrice * supportingProduct.quantity;
                  const unitPrice = calculateUnitPrice(supportingProduct.pricing_policy, supportingProduct.standard_markup, basePrice)
       
            
                  const vendorTotalProfit = parseFloat(supportingProduct.total_price) - parseFloat(vendorTotalCost)

                  sectionObject.productData.push({
                    isMainSectionProduct: false,
                    name: supportingProduct.product.name,
                    manufacture: supportingProduct.manufacture,
                    description: supportingProduct.description,
                    unit_type : supportingProduct.unit_type,
                    quantity: supportingProduct.quantity,
                    pricingPolicy : supportingProduct.pricing_policy,
                    u_cost : basePrice,
                    t_cost : totalCost,
                    standard_markup : supportingProduct.standard_markup,
                    u_price : unitPrice,
                    t_price : supportingProduct.total_price,
                    v_discount : discountValue || '',
                    v_unit_cost:parseFloat(vendorUnitCost)?.toFixed(2),
                    v_total_cost : vendorTotalCost.toFixed(2),
                    v_total_profit : vendorTotalProfit.toFixed(2),
                  });
                });
              }
            });

            // Sub Sections
            if (sectionData.sub_sections && sectionData.sub_sections.length > 0) {
              sectionData.sub_sections.forEach((subSection, subSectionIndex) => {
                totalRows +=1;
                const subSectionObject = {
                  hashLabel: subSectionIndex+1, // Generate A, B, C, ...
                  section: subSection.section, // Copy the section value
                  productData: []
                };

                // Sub Section Products
                subSection.products.forEach((subSectionProduct) => {
                  totalRows +=1;
                  const basePrice = parseFloat(subSectionProduct.converted_price || 0)
                  const discountValue = parseFloat(subSectionProduct.discount || 0);
                  const vendorUnitCost = calculateVendorUnitCost(subSectionProduct.pricing_policy, basePrice, discountValue)
    
                  const vendorTotalCost = vendorUnitCost * subSectionProduct.quantity
                  const totalCost = basePrice * subSectionProduct.quantity;
                  const unitPrice = calculateUnitPrice(subSectionProduct.pricing_policy, subSectionProduct.standard_markup, basePrice)
       
            
                  let vendorTotalProfit = parseFloat(subSectionProduct.total_price) - parseFloat(vendorTotalCost)
                  // if(!(discountValue < subSectionProduct.standard_markup) && !(subSectionProduct.pricing_policy == pricingPolicyOptions.manufacture_discount.value) ){
                  //   vendorTotalProfit = Math.abs()
                  // } 
                  // Add sub-section main product
                  subSectionObject.productData.push({
                    isMainSectionProduct: true,
                    name: subSectionProduct.product_name,
                    manufacture: subSectionProduct.manufacture,
                    description: subSectionProduct.description,
                    unit_type : subSectionProduct.unit_type,
                    quantity: subSectionProduct.quantity,
                    pricingPolicy : subSectionProduct.pricing_policy,
                    u_cost : basePrice,
                    t_cost : totalCost,
                    standard_markup : subSectionProduct.standard_markup,
                    u_price : unitPrice,
                    t_price : subSectionProduct.total_price,
                    v_discount : discountValue || '',
                    v_unit_cost:parseFloat(vendorUnitCost)?.toFixed(2),
                    v_total_cost : vendorTotalCost.toFixed(2),
                    v_total_profit : vendorTotalProfit.toFixed(2),
                  });

                  // Add supporting products
                  if (subSectionProduct.supporting_products && subSectionProduct.supporting_products.length > 0) {
                    subSectionProduct.supporting_products.forEach((supportingProduct) => {
                      totalRows +=1;
                      const basePrice = parseFloat(supportingProduct.converted_price || 0)
                      const discountValue = parseFloat(supportingProduct.discount || 0);
                      const vendorUnitCost = calculateVendorUnitCost(supportingProduct.pricing_policy, basePrice, discountValue)
        
                      const vendorTotalCost = vendorUnitCost * supportingProduct.quantity
                      const totalCost = basePrice * supportingProduct.quantity;
                      const unitPrice = calculateUnitPrice(supportingProduct.pricing_policy, supportingProduct.standard_markup, basePrice)
           
                
                      const vendorTotalProfit = parseFloat(supportingProduct.total_price) - parseFloat(vendorTotalCost)
                      subSectionObject.productData.push({
                        isMainSectionProduct: false,
                        name: supportingProduct.product.name,
                        manufacture: supportingProduct.manufacture,
                        description: supportingProduct.description,
                        unit_type : supportingProduct.unit_type,
                        quantity: supportingProduct.quantity,
                        pricingPolicy : supportingProduct.pricing_policy,
                        u_cost : basePrice,
                        t_cost : totalCost,
                        standard_markup : supportingProduct.standard_markup,
                        u_price : unitPrice,
                        t_price : supportingProduct.total_price,
                        v_discount : discountValue || '',
                        v_unit_cost:parseFloat(vendorUnitCost)?.toFixed(2),
                        v_total_cost : vendorTotalCost.toFixed(2),
                        v_total_profit : vendorTotalProfit.toFixed(2),
                      });
                    });
                  }
                });

                // Add sub-section object to sectionObject
                sectionObject.subSection.push(subSectionObject);
              });
            }

            // Add sectionObject to formattedProductData
            formattedProductData.push(sectionObject);
          });
        }else{
          totalRows = 0
          productData.forEach((pData, pIndex) => {
            totalRows +=1;
            // Main Products
            const basePrice = parseFloat(pData.converted_price || 0)
            const discountValue = parseFloat(pData.discount || 0);
            const vendorUnitCost = calculateVendorUnitCost(pData.pricing_policy, basePrice, discountValue)

            const vendorTotalCost = vendorUnitCost * pData.quantity
            const totalCost = (basePrice * (pData.quantity || 0)).toFixed(2);
            const unitPrice = calculateUnitPrice(pData.pricing_policy, pData.standard_markup, basePrice)
 
      
            const vendorTotalProfit = parseFloat(pData.total_price) - parseFloat(vendorTotalCost)

          // Add main product
          formattedProductData.push({
            isMainSectionProduct: false,
            name: pData.product_name,
            manufacture: pData.manufacture,
            description: pData.description,
            unit_type : pData.unit_type,
            quantity: pData.quantity,
            pricingPolicy : pData.pricing_policy,
            u_cost : basePrice,
            t_cost : totalCost,
            standard_markup : pData.standard_markup,
            u_price : unitPrice,
            t_price : pData.total_price,
            v_discount : discountValue || '',
            v_unit_cost:parseFloat(vendorUnitCost)?.toFixed(2),
            v_total_cost : vendorTotalCost.toFixed(2),
            v_total_profit : vendorTotalProfit.toFixed(2),
          });


          // Add supporting products
          if (pData.supporting_products && pData.supporting_products.length > 0) {
              pData.supporting_products.forEach((supportingProduct) => {
                totalRows +=1;

                const basePrice = parseFloat(supportingProduct.converted_price || 0)
                const discountValue = parseFloat(supportingProduct.discount || 0);
                const vendorUnitCost = calculateVendorUnitCost(supportingProduct.pricing_policy, basePrice, discountValue)

                const vendorTotalCost = vendorUnitCost * supportingProduct.quantity
                const totalCost = basePrice * supportingProduct.quantity;
                const unitPrice = calculateUnitPrice(supportingProduct.pricing_policy, supportingProduct.standard_markup, basePrice)
      
          
                const vendorTotalProfit = parseFloat(supportingProduct.total_price) - parseFloat(vendorTotalCost)

                formattedProductData.push({
                  isMainSectionProduct: false,
                  name: supportingProduct.product_name,
                  manufacture: supportingProduct.manufacture,
                  description: supportingProduct.description,
                  unit_type : supportingProduct.unit_type,
                  quantity: supportingProduct.quantity,
                  pricingPolicy : supportingProduct.pricing_policy,
                  u_cost : basePrice,
                  t_cost : totalCost,
                  standard_markup : supportingProduct.standard_markup,
                  u_price : unitPrice,
                  t_price : supportingProduct.total_price,
                  v_discount : discountValue || '',
                  v_unit_cost:parseFloat(vendorUnitCost)?.toFixed(2),
                  v_total_cost : vendorTotalCost.toFixed(2),
                  v_total_profit : vendorTotalProfit.toFixed(2),
                });
              });
          }
          })
        }

        formattedFinalData.productData = formattedProductData;
        formattedFinalData.totalRows = totalRows
        return formattedFinalData;

      }catch(err){
      console.log("error", err.message);
    }
}